/**
 * Model to hold ranking settings
 */
import { DateTimeZonePipe } from '@reg/shared/pipe';

export class RankingSettings {
    public pointsCalculationId: string = null;
    public rankTopCount: number = null;
    public groupAssignmentId: string = null;
    public rankingPriorityIds: string[] = null;
    public lastRunDateTime: Date = null;

    public getLastRunDateTimeFormatted(timeZone: string): string {
        if (!this.lastRunDateTime) {
            return 'Never';
        }

        return new DateTimeZonePipe().transform(this.lastRunDateTime, timeZone);
    }

    public isEmpty(): boolean {
        return !this.pointsCalculationId &&
            !this.rankTopCount &&
            !this.groupAssignmentId &&
            (!this.rankingPriorityIds || !this.rankingPriorityIds.length);
    }

    public clone(): RankingSettings {
        const clone: RankingSettings = new RankingSettings();
        clone.pointsCalculationId = this.pointsCalculationId;
        clone.rankTopCount = this.rankTopCount;
        clone.groupAssignmentId = this.groupAssignmentId;
        clone.lastRunDateTime = this.lastRunDateTime ? new Date(this.lastRunDateTime.getTime()) : null;
        clone.rankingPriorityIds = this.rankingPriorityIds ? this.rankingPriorityIds.map((id: string) => id) : null;

        return clone;
    }

    public serialize(): any {
        return {
            pointsCalculationId: this.pointsCalculationId,
            rankTopCount: this.rankTopCount ? parseInt(this.rankTopCount.toString(), null) : null,
            groupAssignmentId: this.groupAssignmentId,
            rankingPriorityIds: this.rankingPriorityIds,
        };
    }

    public deserialize(json: any): RankingSettings {
        if (!json) {
            return this;
        }

        this.pointsCalculationId = json.pointsCalculationId;
        this.rankTopCount = json.rankTopCount;
        this.groupAssignmentId = json.groupAssignmentId;
        this.rankingPriorityIds = json.rankingPriorityIds;
        this.lastRunDateTime = json.lastRunTimestamp ? new Date(json.lastRunTimestamp) : null;

        return this;
    }
}
